import React, { useEffect, useState } from "react";
import { connect, ConnectedProps } from "react-redux";
import { RootState } from "../../../store";
import {
  Button,
  Table,
  TableTR,
  Filter,
  FilterValue,
} from "../../../components";
import AddOrgForm from "@/components/Organisation/AddOrgForm";
import { getListOrganization } from "@/store/constants/constants.action";
import EditOrgForm from "@/components/Organisation/EditOrgForm";
import { Display_Value_Key as dvk } from "@/components/Create/utils";
import { removeDuplicateKeys } from "@/store/media/media.action";
import Modal from "@/components/Modal/Modal";
const headers: { name: string; width: string }[] = [
  { name: "Id", width: "10%" },
  { name: "Name", width: "15%" },
  // { name: 'Description', width: '25%' },
  { name: "Status", width: "15%" },
  { name: "Action", width: "10%" },
];

const OrganizationList = ({ organizationList, getListOrganization }: Props) => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState<boolean>(false);
  const [selectedOrg, setSelectedOrg] = useState<any>(null);
  const [filters, setFilters] = useState<Record<string, FilterValue>>({});
  const [availableFilters, setAvailableFilters] = useState<Filter[]>([]);

  const handleModalOpen = () => setIsModalOpen(true);
  const handleModalClose = () => setIsModalOpen(false);

  const handleEdit = (business: any) => {
    setSelectedOrg(business);
    setIsEditModalOpen(true);
  };

  useEffect(() => {
    setAvailableFilters([
      {
        displayName: "Name",
        name: "name",
        type: "text",
        suffix: "contains",
      },
      {
        displayName: "Id",
        name: "id",
        type: "text",
        suffix: ":",
      },
      {
        displayName: "Status",
        name: "status",
        type: "radio",
        suffix: ":",
        options: [
          { label: "Active", value: "1", displayValue: "Active" },
          { label: "Inactive", value: "2", displayValue: "Inactive" },
        ],
      },
    ]);
    setFilters((prevFilters) => ({
      ...prevFilters,
      status: "1",
      statusdisplayValue: "Active",
    }));
  }, []);

  useEffect(() => {
    const updatedFilters = {
      ...removeDuplicateKeys(filters),
      status:
        filters.status !== null && filters.status !== undefined
          ? typeof filters.status === "string"
            ? parseInt(filters.status, 10)
            : filters.status
          : filters.status,
    };
    getListOrganization(updatedFilters);
  }, [filters]);

  const handleFilterChange = (
    key: string | "clear",
    value?: FilterValue,
    displayValue?: FilterValue
  ) => {
    const allowedKeys = ["rows", "page"];
    if (key === "clear") {
      setFilters((prevFilters) => ({
        rows: prevFilters.rows,
        page: prevFilters.page,
      }));
    } else if (allowedKeys.includes(key)) {
      if (value !== undefined && value !== null) {
        setFilters((state) => ({
          ...state,
          [key]: value,
          [key + dvk]: displayValue,
        }));
      } else {
        setFilters((state) => {
          const { [key]: _, ...newState } = state;
          return newState;
        });
      }
    } else {
      if (value !== undefined && value !== null) {
        setFilters((prevFilters) => ({
          ...prevFilters,
          [key]: value,
          [key + dvk]: displayValue,
          rows: prevFilters.rows,
          page: prevFilters.page,
        }));
      } else {
        setFilters((prevFilters) => {
          const { [key]: _, [key + dvk]: c, ...newState } = prevFilters;
          return {
            ...newState,
            rows: prevFilters.rows,
            page: prevFilters.page,
          };
        });
      }
    }
  };

  const filteredList = organizationList.filter((org: any) => {
    return Object.entries(filters).every(([key, value]) => {
      if (!value) return true;

      switch (key) {
        case "name":
          return org.name
            .toLowerCase()
            .includes(value.toString().toLowerCase());
        case "id":
          return org.id.toLowerCase().includes(value.toString().toLowerCase());
        case "status":
          return org.status;
        default:
          return true;
      }
    });
  });

  const handleEditModalClose = () => {
    setSelectedOrg(null);
    setIsEditModalOpen(false);
  };

  return (
    <>
      <div className="subHeader d-flex justify-content-between align-items-center px-3 py-2">
        <h5>ORGANIZATION</h5>
        <div className="d-flex align-items-center">
          <span className="px-2 me-2 H">
            <i className="bi bi-download fs-5"></i>
          </span>
          <Button
            className="ms-2"
            type="outline-primary"
            onClick={handleModalOpen}
          >
            ADD NEW
          </Button>
        </div>
      </div>
      {isModalOpen && (
        <Modal
          isOpen={isModalOpen}
          onClose={handleModalClose}
          title="Add New Organization"
          width="60vw"
        >
          <AddOrgForm onClose={handleModalClose} />
        </Modal>
      )}
      {isEditModalOpen && (
        <Modal
          isOpen={isEditModalOpen}
          onClose={handleEditModalClose}
          title={`Edit Organization: ${selectedOrg?.name || ""}`}
          width="60vw"
        >
          {selectedOrg && (
            <EditOrgForm
              organization={selectedOrg}
              onClose={handleEditModalClose}
            />
          )}
        </Modal>
      )}
      <Table
        columns={headers}
        isLoading={false}
        totalCount={organizationList.length}
        onFilterChange={handleFilterChange}
        appliedFilters={filters}
        availableFilters={availableFilters}
      >
        {filteredList.map((item: any) => (
          <TableTR key={item.id} rowKey={item.id}>
            <td>
              <div className="p-2 d-flex align-items-center">{item.id}</div>
            </td>
            <td>
              <div className="p-2 d-flex align-items-center">{item.name}</div>
            </td>
            <td>
              <div className="p-2 d-flex align-items-center">
                {item.status === 1 ? "Active" : "Inactive"}
              </div>
            </td>
            <td style={{ textAlign: "center" }}>
              <div className="d-flex align-items-center p-2">
                <span
                  className="px-2"
                  onClick={() => handleEdit(item)}
                  style={{ cursor: "pointer" }}
                >
                  <i className="bi bi-pencil"></i>
                </span>
              </div>
            </td>
          </TableTR>
        ))}
      </Table>
    </>
  );
};

const mapState = (state: RootState) => ({
  organizationList: state.constants.organizationList.list,
});

const mapDispatch = {
  getListOrganization,
};

const connector = connect(mapState, mapDispatch);
type Props = ConnectedProps<typeof connector>;
export default connector(OrganizationList);
